import React from 'react';
import { Provider as ReakitProvider } from 'reakit';
import { Context, TranslationStrings, defaultTranslationStrings } from '../../Context';

interface UIProviderProps {
    children: React.ReactNode;
    translationStrings?: TranslationStrings;
}

// Composes all providers necessary for UI components inside this library
export function UIProvider({ children, translationStrings }: UIProviderProps) {
    return (
        <Context.Provider
            value={{ translationStrings: translationStrings ?? defaultTranslationStrings }}
        >
            <ReakitProvider>{children}</ReakitProvider>
        </Context.Provider>
    );
}
